// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import api from "./api";
import "less";
import "./assets/icon.css";
import store from "./store";
import './assets/css/common.css'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import router from "./router";

Vue.prototype.axios = api.axios;
Vue.prototype.$axios = api.axios;
Vue.prototype.$get = api.get;
Vue.prototype.$post = api.post;
Vue.prototype.$Getcoach = api.Getcoach;

import { ObjectChangedValue, Ts } from "./api/public.js";
Vue.prototype.$ObjectChangedValue = ObjectChangedValue;
Vue.prototype.$Ts = Ts;

import AMapLoader from "@amap/amap-jsapi-loader";
let map = AMapLoader.load({
  key: "c0c6e86a15067065d61ffb5d309f8308", // 申请好的Web端开发者Key，首次调用 load 时必填
  version: "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
  plugins: ["AMap.Geocoder", "AMap.PlaceSearch", "AMap.Autocomplete"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
  AMapUI: {
    // 是否加载 AMapUI，缺省不加载
    version: "1.1", // AMapUI 缺省 1.1
    plugins: ["misc/PoiPicker"], // 需要加载的 AMapUI ui插件
  },
  Loca: {
    // 是否加载 Loca， 缺省不加载
    version: "1.3.2", // Loca 版本，缺省 1.3.2
  },
});
Vue.prototype.$map = map;

import assembly from "./api/assembly";
Vue.use(assembly);

import TIM from "tim-js-sdk";
let options = {
  SDKAppID: 1400782437, 
};

import TIMUploadPlugin from "tim-upload-plugin";

let im = TIM.create(options);
im.registerPlugin({
  "tim-upload-plugin": TIMUploadPlugin,
});
Vue.prototype.$tim = im;
Vue.prototype.$tims = TIM;
im.setLogLevel(1);
Vue.config.productionTip = false;

Vue.prototype.TimRoll = new Vue();

Vue.prototype.getStorageSync = function(name){
  return JSON.parse( localStorage.getItem(name))
}

Vue.prototype.setStorageSync = function(name,value){
  localStorage.setItem(name,JSON.stringify(value))
}

Vue.prototype.timeToTemp = function(time){
  return new Date(time.replace(/\-/g,"/")).getTime()
} 
Vue.prototype.$StateTips = function (e) {
  let data = {
    null: "未完善资料",
    0: "未完善资料",
    1: "正在审核中",
    5: "您的账号已被冻结,请联系客服",
  };
  uni.showToast({
    icon: "none",
    title: data[e],
    duration: 2000,
  });
};

function rad(d) {
  return (d * Math.PI) / 180.0;
}
Vue.prototype.$Distance = function (lat1, lng1, lat2, lng2) {
  var radLat1 = rad(lat1);
  var radLat2 = rad(lat2);
  var a = radLat1 - radLat2;
  var b = rad(lng1) - rad(lng2);
  var s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = s * 6378.137; // EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000; //输出为公里
  var distance = s;
  var distance_str = "";
  if (parseInt(distance) >= 1) {
    distance_str = distance.toFixed(1) + "km";
  } else {
    distance_str = distance * 1000 + "m";
  }
  return s.toFixed(1);
};

Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

// import './Rem'
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>",
  router,
  store,
});
